import { Button, Box, Drawer, DialogTitle, Typography } from "@material-ui/core";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { FC } from "react";
import { useDispatch } from "react-redux";
import { useCustomDrawerStyles } from "./styles";
import { closeDrawer, openDrawer } from "actions/drawerActions";
import useResize from "hooks/useResize";

interface DCustomDrawerProps {
  customWidth: number;
  buttonType: "icon" | "text" | "custom" | "none";
  children: any;
  drawer_name: string;
  fullWidth?: boolean;
  buttonText?: string;
  drawerTitle: string;
  isDisabled?: boolean;
  customButtonElement?: any;
  customOnClick?: any;
  disableMobileFullWidth?: boolean;
}

export const CustomDrawer: FC<DCustomDrawerProps> = ({
  customWidth,
  buttonType,
  fullWidth,
  children,
  drawer_name,
  buttonText,
  drawerTitle,
  isDisabled,
  customButtonElement,
  customOnClick,
  disableMobileFullWidth,
}) => {
  const classes = useCustomDrawerStyles();
  const { width } = useResize();
  const dispatch = useDispatch();
  const { isOpen, drawerName } = useTypeSelectors((state) => state.drawerState);
  const triggerOnClick = () => {
    if (!customOnClick) {
      dispatch(openDrawer(drawer_name));
    } else {
      dispatch(customOnClick);
    }
  };

  return (
    <>
      {buttonType === "text" && (
        <Button
          className={classes.openBtn}
          variant="text"
          fullWidth={fullWidth}
          onClick={triggerOnClick}
          disabled={isDisabled}
        >
          {buttonText}
        </Button>
      )}{" "}
      {buttonType === "custom" && (
        <Box
          className={`${classes.customButtonElement} ${isDisabled ? classes.disabledButton : ""}`}
          onClick={triggerOnClick}
        >
          {customButtonElement}
        </Box>
      )}
      <Drawer
        anchor="right"
        open={isOpen && drawerName === drawer_name}
        onClose={() => dispatch(closeDrawer())}
        PaperProps={{
          style:
            width > 840 || disableMobileFullWidth
              ? { minWidth: customWidth, maxWidth: customWidth }
              : { minWidth: "100%", maxWidth: "100%" },
        }}
        BackdropProps={{
          classes: {
            root: classes.backDrop,
          },
        }}
      >
        <DialogTitle className={classes.drawerTitle}>
          <Typography className={classes.drawerTitleText}>{drawerTitle}</Typography>
        </DialogTitle>
        {children}
      </Drawer>
    </>
  );
};
